export default __webpack_public_path__ + "static/media/bigLogo.a896b094.svg";